module.exports = __webpack_public_path__ + "static/media/logo_new.314b49bc.jpg";